import React from "react";
import "../style.css";

const ShopifyHomepage = () => {
  // Function to scroll to the #ShowCase section
  const scrollToShowCase = () => {
    const showcaseElement = document.getElementById("ShowCase");
    if (showcaseElement) {
      showcaseElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero-section">
      <div className="drawer-container">
        <div className="hero-header">
          <p className="hero-tagline">
            Designed for creators • Built for growth • Your premium Shopify partner
          </p>
          <h1>
            Premium Shopify sections, <span className="highlight">free</span> – no developer required.
          </h1>
          <p className="hero-description">
            Replace expensive Shopify apps with free, premium custom sections crafted for your store.
          </p>
          <div className="hero-buttons">
            {/* Button to scroll to the showcase section */}
            <button className="btn btn-primary" onClick={scrollToShowCase}>
              Get Started
            </button>
            <button className="btn btn-secondary" onClick={scrollToShowCase}>
              Explore Sectionss
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopifyHomepage;
